import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Anchor, Truck, ClipboardCheck, Globe2, ShieldCheck } from 'lucide-react';

const serviceIcons = {
  cargo: Container,
  agency: Anchor,
  inland: Truck,
  customs: ClipboardCheck,
  forwarding: Globe2,
  insurance: ShieldCheck,
};

const Services: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="services" className="py-24 bg-white relative">
        <div className="absolute top-0 left-0 w-full h-64 bg-slate-50 -skew-y-3 origin-top-left -z-10"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-marine-600 font-semibold tracking-wide uppercase text-sm">{t('services.expertise')}</span>
          <h2 className="mt-2 text-3xl md:text-4xl font-bold text-slate-900">{t('services.title')}</h2>
          <p className="mt-4 max-w-2xl mx-auto text-xl text-slate-500">
            {t('services.desc')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {Object.entries(serviceIcons).map(([key, Icon]) => (
            <div 
              key={key} 
              className="group relative bg-white rounded-2xl p-8 shadow-lg border border-slate-100 hover:border-marine-200 transition-all duration-300 hover:shadow-2xl hover:-translate-y-1"
            >
              <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity">
                <Icon className="w-24 h-24 text-marine-600" />
              </div>
              
              <div className="w-14 h-14 bg-marine-50 rounded-xl flex items-center justify-center text-marine-600 mb-6 group-hover:bg-marine-600 group-hover:text-white transition-colors">
                <Icon className="w-7 h-7" />
              </div>
              
              <h3 className="text-xl font-bold text-slate-900 mb-2">{t(`services.items.${key}.title`)}</h3>
              {/* Removed secondary title for full localization */}
              
              <p className="text-slate-600 leading-relaxed mb-6">
                {t(`services.items.${key}.desc`)}
              </p>
              
              <a href="#contact" className="inline-flex items-center text-marine-700 font-semibold hover:text-marine-900 transition-colors">
                {t('services.learn_more')} <span className="ml-1 text-xl">›</span>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
